import React, { useState, useRef, useEffect, } from 'react';
import { ReactTabulator } from 'react-tabulator';
import { useTranslation } from 'react-i18next';
import { Modal, Row, Col, Card } from 'react-bootstrap';
import API from '../../api/api.jsx';

// 결재대기 화면에서 결재상태 클릭 시 등장하는 모달
const Loan_002_05 = ({ showModal, setShowModal, loan_application_id, loanApplicationId}) => {
    const { t }                           = useTranslation();
    const [responseData, setResponseData] = useState([]);
    const tableRef                        = useRef(null);

    // Tabulator columns 목록
	const columns = [
		{formatter:"rowSelection", titleFormatter:"rowSelection", headerHozAlign: 'center', hozAlign:"center", headerSort:false, width:30, cellClick:function(e, cell){
			cell.getRow().toggleSelect();
		}},
		{ title: t('APPROVAL.결재선명', { defaultValue: '결재선명' }), field: 'line_name', headerHozAlign: 'center', hozAlign: 'center', width: 200 , visible: true},		
		{ title: t('LOAN_APPLICATION.이름', { defaultValue: '이름' }), field: 'names', headerHozAlign: 'center', hozAlign: 'center', },		
	];

    // 화면 접근 시 결재선 목록 불러오기
    useEffect(() => {        
        const fetchLoan00301Data = async () => {
            try {
                const data = await API.fetchLoan00301Data({  });                

                setResponseData(data);                
                
            } catch (error) {
                console.error('Error in fetchSanc00201Data Error:', error);
            }
        };        

        if (showModal) {            
            fetchLoan00301Data();
        }

    }, [showModal]);

    // 결재요청 버튼 클릭 시 호출되는 함수
    const handleCheck = async () => {
        // Loan_002_05 컴포넌트로부터 전달받은 id 중 존재하는 값을 찾기
        const id = loan_application_id || loanApplicationId;

        if (tableRef.current) {
            const selectedData = tableRef.current.getSelectedData();

            if (selectedData.length === 0) {
                alert("결재선을 선택해주세요.");
                return;
            }

            try {
                const data = await API.fetchLoan00205DataPOST({ id, selectedData });

                alert(data.message);
                setShowModal(false);
                // 부모 창(loan_002_06)에게 메시지 전달
                window.parent.postMessage("CLOSE_SELF", "*");
                // window.parent.postMessage({ action: "CLOSE_SELF", target: "loan_002_06" }, "*");
                window.location.reload()

            } catch (error) {
                console.error('Error ', error);
                return;
            };
        }
    };

    // 모달 닫기
    const handleClose = () => {		
        setShowModal(false);
	};

    return (
        <Modal show={showModal} onHide={handleClose} centered dialogClassName="modal-lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{t(`LOAN_APPLICATION.승인요청`, { defaultValue: '승인요청' })}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <ReactTabulator
                        onRef={(r) => (tableRef.current = r.current)}
                        columns={columns}
                        data={responseData}
                        options={{
                            layout: "fitColumns",
                            height: "540px",                                                        
                            placeholder: "No Data Found",
                            rowFormatter: function (row) {
                                row.getElement().style.fontSize = "14px";
                            },
                            selectable: false,
                        }}
                        className="responsive-tabulator"
                    />
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-between">
                    <div>
                        <button className="btn btn-outline-gray me-1 mb-1 w-100px" onClick={handleClose}>
                            <i className="fa fa-backward"></i> {t('COMMON.이전', { defaultValue: '이전' })}
                        </button>
                    </div>

                    <div>
                        {/* <button className="btn btn-outline-danger me-1 mb-1 w-100px" onClick={handleReject}>
                            선택
                        </button> */}
                        <button className="btn btn-outline-success me-1 mb-1 w-100px" onClick={handleCheck}>
                            {t('LOAN_APPLICATION.결재요청', { defaultValue: '결재요청' })}
                        </button>
                    </div>
                </Modal.Footer>
        </Modal>

    );
}

export default Loan_002_05;